"use client";

import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Loader, Mail } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SubscribeCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return;
}
function SubscribeForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="text-center space-y-4">
        <div className="inline-flex items-center justify-center size-16 bg-secondary/10 rounded-full mb-2">
          <Mail className="size-8 text-secondary" />
        </div>
        <p className="text-lg font-semibold text-foreground">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="mt-4">
          Subscribe Another Email
        </Button>
      </div>;
  }
  return <div className="space-y-6">
      <div className="text-center space-y-2">
        <h2 className="text-2xl font-bold text-foreground">Stay Updated</h2>
        <p className="text-muted-foreground">
          Subscribe to receive the latest resources and updates from Education Family Tutors.
        </p>
      </div>

      <Form onSubmit={handleSubmit}>
        <div className="space-y-4">
          <FormField control={control} name="email" rules={{
          required: "Email is required",
          pattern: {
            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            message: "Please enter a valid email address"
          }
        }} render={({
          field
        }) => <FormItem>
                <FormLabel className="sr-only">Email Address</FormLabel>
                <FormControl>
                  <Input type="email" placeholder="Enter your email address" className="h-12 px-4 text-base focus-visible:shadow-[0_0_0_4px_hsla(210,35%,18%,0.1)] transition-shadow duration-[var(--duration-fast)]" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>} />

          {submitError && <div className="p-4 bg-red-50 border border-red-200 rounded-md">
              <p className="text-red-800 text-sm">{submitError}</p>
            </div>}

          <Button type="submit" disabled={isSubmitting} className="w-full h-12 bg-secondary text-foreground-secondary font-semibold hover:bg-secondary-hover active:bg-secondary-active transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
            {isSubmitting ? <>
                <Loader className="animate-spin mr-2 size-5" />
                Subscribing...
              </> : <>
                <Mail className="mr-2 size-5" />
                Subscribe
              </>}
          </Button>
        </div>
      </Form>
    </div>;
}